
<template>
  <div class="signup app-content">

    <DashboardMenu></DashboardMenu> 
    <div class="bg-blue pb-5">
      <div class="container bg-blue">
        <div class="row mx-2 pb-3 pt- ">
          <div class="col-md-3 col-sm-12 col-lg-3 job-dashboard-main">

            <div class="col-12 col-lg-12 job-guide-box mt-4 p-2 px-3">
              <h2 class="py-2 text-center search-panel-title">検索条件</h2>
              <label class="pt-2">あなたの希望する職種</label>
              <b-form-select v-model="industry" class="dirty custom-select" :options="INDUSTRY_OPTIONS"></b-form-select>

              <label class="pt-3">あなたの希望する勤務地</label>
              <b-form-select v-model="prefecture" class="dirty custom-select" :options="PREFECTURES"></b-form-select>

              <label class="pt-3">あなたの希望する月収</label>

              <b-form-select v-model="income" class="dirty custom-select" :options="INCOMES"></b-form-select>

              <b-button @click="searchJob" pill block class='orange-button mt-4 mx-0 mb-4 no-border'>検索する</b-button>
            </div>
          </div>
          <div class="col-md-9 col-sm-12 col-lg-9 ">
            <div class="d-flex justify-content-between pt-4">
              <p class="mb-0 job-dashboard-title"><b-icon class="h5 mb-0 mt-2 mr-2" icon="question-circle" style='color: gray'></b-icon>検索結果一覧</p>
            </div>

            <div v-if="jobs.length > 0" class="row">
              <div v-for="job in jobs" :key="job.id" class="col-md-6 col-sm-12 col-lg-6 px-3 py-3 ">
                <div class="card shadow-sm card-border">
                  <div class="card-body">
                    <b-row>
                      <div class="col-6 col-lg-6 pr-2">
                        <img :src="job.images" class="w100"/>
                      </div>
                      <div class="col-6 col-lg-6 pl-2">
                        <img :src="job.outside_office_image" class="w100"/>
                      </div>
                    </b-row>
                    <p class="card-text mb-1 pt-3">{{ job.title }}</p>
                    <small> 職種: {{ job.occupation }} / {{ INDUSTRY_DICTIONARY[job.industry] }}<br/>勤務地：{{ job.location }}</small><br/>
                    <small class="">月収: {{ job.month_salary_from }} 〜 {{ job.month_salary_to }}万円</small>

                    <div class="d-flex justify-content-between">
                      <a type="button" :href="'jobs/' + job.id" class="btn btn-sm btn-block btn-outline-primary mt-2 mx-1">詳しくみる</a>
                      <a type="button" :href="'jobs/' + job.id" class="btn btn-sm btn-block btn-outline-primary mt-2 mx-1">お気に入り登録</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="row">
              <b-alert class="text-center mx-auto my-2 w-ful" variant="dark" show>検索条件にマッチする求人はありませんでした</b-alert>
            </div>
          </div>
        </div>


      </div>
    </div>
    <info-modal ref="info"></info-modal>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import DashboardMenu from "@/components/User/Jobs/DashboardMenu"
import InfoModal from "@/components/InfoModal"

export default {
  components: {
    InfoModal, DashboardMenu
  },
  data () {
    return {
      idToken: localStorage.idToken,
      jobs: [],
      meta: {},
      recruits: [],
      options: [],
      select_industry: null,
      industry: "",
      prefecture: "",
      income: "",
      dormitory: "",
      industry_placeholder: this.$i18n.t('message.select_ouccupation'),
      salaryOptions: {
        'hourt': '時給' ,
        'week': '週給',
        'month': '月給' ,
        'year': '年収' ,
      },
      occupactionDict: {
        "full": this.$i18n.t('message.full_time_employee'),
        "part": this.$i18n.t('message.part_time_job'),
        "temporary": this.$i18n.t('message.temporary_staff'),
        "contract": this.$i18n.t('message.contract_employee')
      },
    }
  },
  methods: {
    makeOccupation(){
      this.options = []
      this.occupation = this.memberInfo.current_industry
      var interested_list = []
      if (this.memberInfo.interested_list != [] || this.memberInfo.interested_list != undefined){
        interested_list = this.memberInfo.interested_industry.toString().split(',')
      }
      for(var item of interested_list){
        this.options.push({value: item, text: this.$i18n.t('message.industry_id_' + item)})
      }
    },
    searchJob: function() {
      this.fetch_jobs()
    },
    fetch_jobs: function() {
      this.$store.commit('setLoading', true)
      var query = "?industry=" + this.industry + "&prefecture=" + this.prefecture + "&income=" + this.income + "&prefecture=" + this.prefecture
      axios
        .get(process.env.VUE_APP_API + "/api/seeker/jobs" + query,{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.jobs = response.data.jobs
          this.meta = response.data.meta
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is error', error)
        })
    },
    format_industry(industry_id){
      console.log(industry_id)
    },
    showInfoModal(title='message.sample_title', description='message.sample_description'){
      this.$refs.info.showModal(this.$i18n.t(title), this.$i18n.t(description))
    },
    salaryParse(job, t) {
      if(job.salary != null){
        var salary_list = job.salary.split('~')
        if(t == "min") {
          return salary_list[0]
        } else {
          return salary_list[1]
        }
      } else {
        return "-"
      }
    },
  },
  async mounted() {
    this.$store.commit('setLoading', false)
    this.industry = this.$route.query.industry
    this.prefecture = this.$route.query.prefecture
    this.income = this.$route.query.income
    this.dormitory = this.$route.query.dormitory

    this.fetch_jobs()
  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language,
        outh: state => state.user.outh
    })
  },
  watch:{
    language(){
      this.examination_day = this.$i18n.t('message.no_examination')

    },
    select_industry(){
      if( this.select_industry != this.memberInfo.current_industry && this.select_industry != null){
        axios
        .patch(process.env.VUE_APP_API + "/users/" + this.memberInfo.id,{user: {current_industry: this.select_industry}},{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.$store.commit('user/setOccupation', this.select_industry)
          this.makeOccupation()
        }).catch(error => {
          console.log('this is error', error)
        })
      }
    }
  }


}
</script>

<style scoped lang="scss">

.job-side-p {
  font-size: 20px;
  font-weight: bold;
}
.sample-box {
  background-color: #EFEFEF;
  border: 1px solid #CDCDCD;
  height: 150px;
}

.job-dashboard-title {
  font-size: 20px;
  font-weight: bold;
  color: #4E4E4E;
}
.search-bar {
  background-color: #006FD2;
  border-radius: 15px;
  span {
    color: white;
  }
}
.notification-bar {
  background-color: #fff;
  border-radius: 60px;
  border: 2px solid #D4D4D4;
}
.notify-num {
  color: #F29147;
  font-size: 24px;
}
.notify-p {
  color: red;
  text-decoration: underline;
  text-align: center;
}
.w100 {
  background-color: #EFEFEF;
  border: 1px solid #CDCDCD;
  width: 100%;
  height: 150px;
  object-fit: cover;
}
.search-select-form {
  width: 20%;


}
.w-ful {
  width: 95%;
}
.search-panel-title {
  color: #3479EA;
  font-size: 20px;
}

</style>
